import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-488b8d49")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return _withDirectives((_openBlock(), _createBlock("input", {
    type: "number",
    value: _ctx.localValue,
    onInput: [
      _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue = $event.target.value)),
      _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitModel(_ctx.localValue)))
    ],
    tabindex: _ctx.tabIndex,
    readonly: _ctx.readonly,
    min: _ctx.min,
    max: _ctx.max,
    step: _ctx.step
  }, null, 40, ["value", "tabindex", "readonly", "min", "max", "step"])), [
    [_directive_localizedPlaceholder, { key: _ctx.placeholderKey, value: _ctx.placeholderValue,  prevText: _ctx.placeholderPrevText, afterText: _ctx.placeholderAfterText }]
  ])
})